const debug = false;
export const settings = {
  apiUrl: !debug ? process.env.VUE_APP_API_URL : process.env.VUE_APP_DEBUG_URL as string,
  version: process.env.VUE_APP_VERSION,
  elmahioKey: process.env.VUE_APP_ELMAHIO_KEY,
  elmahioId: process.env.VUE_APP_ELMAHIO_ID,
  elmahioApplication: process.env.VUE_APP_ELMAHIO_APPLICATION_NAME,
};